module.exports = __webpack_public_path__ + "files/4db8bd96e2fab67670cd031d2635b056.png";